import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Config from "./views/Config.vue";
import Public from "./views/Public.vue";
import PublicPlayer from "./views/PublicPlayer.vue";
import Activate from "./views/Activate.vue";
import Protected from "./views/Protected.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "*",
			name: "home",
			component: Home
		},
		{
			path: "/config",
			name: "config",
			component: Config,
			props: true
		},
		{
			path: "/public",
			name: "public",
			component: Public
		},
		{
			path: "/public_player",
			name: "public_player",
			component: PublicPlayer,
			props: route => ({ num_audio: parseInt(route.query.num_audio) })
		},
		{
			path: "/activate",
			name: "activate",
			component: Activate
		},
		{
			path: "/protected",
			name: "protected",
			component: Protected,
			props: true
		}
	]
});
